import { useEffect, useRef } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

const isUrl = (t) => /^https?:\/\/\S+$/i.test((t || "").trim());

export async function uploadImageFile(file) {
  const fd = new FormData();
  fd.append("file", file, file.name || "pegada.png");
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

async function handleFile(file, onImage) {
  const t = toast.loading("Subiendo imagen pegada…");
  try { onImage(await uploadImageFile(file)); toast.success("Imagen pegada", { id: t }); }
  catch (e) { toast.error(apiErr(e), { id: t }); }
}

// Ctrl+V anywhere while active: image -> upload, URL -> use directly (except when typing in a field)
export function usePasteImage(active, onImage) {
  const cb = useRef(onImage);
  cb.current = onImage;
  useEffect(() => {
    if (!active) return undefined;
    const onPaste = (e) => {
      const items = [...(e.clipboardData?.items || [])];
      const img = items.find((i) => i.type.startsWith("image/"));
      if (img) { e.preventDefault(); handleFile(img.getAsFile(), cb.current); return; }
      const text = e.clipboardData?.getData("text") || "";
      const typing = ["INPUT", "TEXTAREA"].includes(e.target?.tagName);
      if (!typing && isUrl(text)) { e.preventDefault(); cb.current(text.trim()); toast.success("Imagen pegada"); }
    };
    window.addEventListener("paste", onPaste);
    return () => window.removeEventListener("paste", onPaste);
  }, [active]);
}

// Button click: read clipboard via Clipboard API
export async function pasteFromClipboard(onImage) {
  try {
    if (navigator.clipboard?.read) {
      for (const item of await navigator.clipboard.read()) {
        const type = item.types.find((t) => t.startsWith("image/"));
        if (type) { await handleFile(new File([await item.getType(type)], "pegada.png", { type }), onImage); return; }
      }
    }
    const text = await navigator.clipboard?.readText?.();
    if (isUrl(text)) { onImage(text.trim()); toast.success("Imagen pegada"); return; }
    toast.error("No hay una imagen copiada. En Google: clic derecho → Copiar imagen");
  } catch {
    toast.info("Presioná Ctrl+V (o Cmd+V) para pegar la imagen");
  }
}
